import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const invoiceBillingFrequenciesAdapter = getAdapter({ idFieldName: 'value' });

const invoiceBillingFrequenciesSlice = createSlice({
  name: 'invoiceBillingFrequencies',
  initialState: invoiceBillingFrequenciesAdapter.getInitialState(),
  reducers: {
    setInvoiceBillingFrequencies: (state, { payload: { invoiceBillingFrequencies } }) => {
      invoiceBillingFrequenciesAdapter.setAll(state, invoiceBillingFrequencies);
    },
  },
});

const selectors = invoiceBillingFrequenciesAdapter.getSelectors(({ invoiceBillingFrequencies }) => invoiceBillingFrequencies);

export const getInvoiceBillingFrequencies = (state) => selectors.selectAll(state);

export const {
  setInvoiceBillingFrequencies,
} = invoiceBillingFrequenciesSlice.actions;

export default invoiceBillingFrequenciesSlice.reducer;
